package com.solevo.dist.application.models

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

// TODO UI model work
// enum class OrderStatus

enum class OrderType {
    SalesOrder, SalesAgreement
}

data class Order(
    val orderId: String = "",
    val totalAmount: Double = 0.0,
    val totalRemainingAmount: Double? = 0.0,
    val status: Status = Status.Created,
    val orderDate: Instant = Clock.System.now(),
    val deliveryNotes: List<DeliveryNote>? = null,
    val orderLines: List<OrderLine>? = null,
    val customerId: String = "",
    val orderReference: String? = null,
    val pickupDateFrom: Instant? = Clock.System.now(),
    val pickupDateTo: Instant? = Clock.System.now(),
    val errorText: String? = null,
    val errorCode: String? = null,
    val appOrder: Boolean? = null,
    val legalEntityId: String? = null,
    val requestedShipDate: Instant? = Clock.System.now(),
    val orderType: OrderType = OrderType.SalesAgreement
) {
    sealed class Status {
        data object Initialized : Status()
        data object Created : Status()
        data object Confirmed : Status()
        data object Expired : Status()
        data object Cancelled : Status()
        data object Closed : Status()
        data object Error : Status()
    }
}

@Serializable
data class OrderLine(
    val id: String? = "",
    val productId: String = "",
    val totalPrice: Double = 0.0,
    val remainingAmount: Double? = 0.0,
    val quantity: Double = 0.0,
    val remainingQuantity: Double = 0.0,
    val pricePerUnit: Double = 0.0,
    val priceUnit: Double = 0.0,
    val unit: String? = null,
    val warehouseId: String = "",
    val lineNumber: Double = 0.0,
)

@Serializable
data class DeliveryNote(
    val id: String = "",
    val unit: String? = null,
    val pickedItems: List<DeliveryNoteLine>? = null,
    val docMetadata: DocMetadata? = null,
    val pickingDate: Instant? = null,
)

@Serializable
data class DeliveryNoteLine(
    val id: String = "",
    val productId: String = "",
    val quantity: Double = 0.0,
    val orderLineId: String? = null,
    val unit: String? = null,
    val lineNumber: Double = 0.0,
    val warehouseName: String? = "",
    val warehouseAddress: String? = null,
    val warehouseId: String? = null,
)
